import { SET_VALUES_SECTION, CLEAR_VALUES_SECTION } from '@constants/actionType'

const initialState = {
  general: null,
  componentsAvailables: [],
  componentsSelected: [],
  banner: null,
  bannerImgR: null,
  bannerImgL: null,
  descriptionImgR: null,
  floatingCards: null,
  documentsCards: null,
  bannerMain: null,
  blocks3: null,
  bannerCodeEthics: null,
  slidersLogos: null,
  bullets: null,
  capacitateEmpleo: null,
  tabsDescripcion: null,
  carousel: null,
  frequentQuestions: null,
  description: null,
  relatedLinks: null,
  informationBlocks: null,
  informationBlocksCarousel: null,
  ultimosDocumentos: null,
  about: null,
  outService: null,
  visibility: null,
  layoutsHtml: null,
  originalHtmlByLanguage: null,
  editable: null,
  id: null,
  id_original: null
};

function section(state = initialState, actions) {
  switch (actions.type) {
    case SET_VALUES_SECTION:
      return { ...state, ...actions.payload };
    case CLEAR_VALUES_SECTION:
      return {
        general: null,
        componentsAvailables: [],
        componentsSelected: [],
        banner: null,
        bannerImgR: null,
        bannerImgL: null,
        descriptionImgR: null,
        floatingCards: null,
        documentsCards: null,
        bannerMain: null,
        blocks3: null,
        bannerCodeEthics: null,
        slidersLogos: null,
        bullets: null,
        tabsDescripcion: null,
        capacitateEmpleo: null,
        carousel: null,
        frequentQuestions: null,
        description: null,
        relatedLinks: null,
        informationBlocks: null,
        informationBlocksCarousel: null,
        ultimosDocumentos: null,
        about: null,
        outService: null,
        visibility: null,
        layoutsHtml: null,
        originalHtmlByLanguage: null,
        editable: null,
        id: null,
        id_original: null
      };
    default:
      return state;
  }
}

export default section;
